// src/components/ActiveOrders.jsx

import React, { useState, useEffect } from 'react';
import api from '../api/api';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import 'moment/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import '../styles/ActiveOrders.css';
import { useNavigate } from 'react-router-dom';



const ActiveOrders = () => {
  const [orders, setOrders] = useState([]);
  const [clients, setClients] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editForm, setEditForm] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
  fetchOrders();
  fetchClients();
  const interval = setInterval(fetchOrders, 5000);
  return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);


  const fetchOrders = async () => {
  try {
    const res = await api.get('/api/orders');
    setOrders(res.data.filter(o => o.status !== 'finished'));
  } catch (err) {
    console.error('Error al obtener pedidos:', err);

    if (err?.response?.status === 401) {
      localStorage.removeItem('token');
      navigate('/'); // cambia a '/login' si tu login está ahí
    }
  }
};


  const fetchClients = async () => {
  try {
    const res = await api.get('/api/clients');
    setClients(res.data);
  } catch (err) {
    console.error('Error al cargar clientes', err);

    if (err?.response?.status === 401) {
      localStorage.removeItem('token');
      navigate('/'); // cambia a '/login' si tu login está ahí
    }
  }
};


  const clientOptions = clients.map(c => ({ value: c.name, label: c.name }));

  const formatStatus = status =>
    status === 'finished'
      ? 'Terminar pedido'
      : status
          .split('-')
          .map(w => w[0].toUpperCase() + w.slice(1))
          .join(' ');

  const handleViewDetail = order => {
    setSelectedOrder(order);
    setModalOpen(true);
    setEditMode(false);
  };

  const handleCloseModal = () => {
    setSelectedOrder(null);
    setModalOpen(false);
  };

  const handleEditOrder = () => {
    if (!selectedOrder) return;
    setEditMode(true);
    setEditForm({
      id: selectedOrder.id,
      fuente: selectedOrder.fuente || '',
      ejecutivo: selectedOrder.ejecutivo || '',
      customer: selectedOrder.customer || '',
      para: selectedOrder.para || '',
      scheduledTime: selectedOrder.scheduledTime,
      parcial: selectedOrder.parcial || '',
      transporte: selectedOrder.transporte || '',
      iva: selectedOrder.iva || 'No',
      detalleEntrega: selectedOrder.detalleEntrega || '',
      recibidoPor: selectedOrder.recibidoPor || '',
      formaPago: selectedOrder.formaPago || '',
      tarjeta: selectedOrder.tarjeta || 'No',
      tarjetaDetalle: selectedOrder.tarjetaDetalle || ''
    });
  };

  const handleEditFormChange = e => {
    const { name, value } = e.target;
    setEditForm(prev => ({ ...prev, [name]: value }));
  };

  const handleUpdateOrder = async e => {
  e.preventDefault();
  try {
    await api.put(`/api/orders/${editForm.id}`, {
      fuente: editForm.fuente,
      ejecutivo: editForm.ejecutivo,
      customer: editForm.customer,
      para: editForm.para,
      scheduledTime: editForm.scheduledTime,
      parcial: editForm.parcial,
      transporte: editForm.transporte,
      iva: editForm.iva,
      detalleEntrega: editForm.detalleEntrega,
      recibidoPor: editForm.recibidoPor,
      formaPago: editForm.formaPago,
      tarjeta: editForm.tarjeta,
      tarjetaDetalle: editForm.tarjeta === 'Si' ? editForm.tarjetaDetalle : ''
    });

    alert('Pedido actualizado con éxito');
    await fetchOrders();
    setSelectedOrder(orders.find(o => o.id === editForm.id));
    setEditMode(false);
  } catch (err) {
    console.error('Error al actualizar pedido:', err);

    if (err?.response?.status === 401) {
      localStorage.removeItem('token');
      navigate('/'); // cambia a '/login' si tu login está ahí
      return;
    }

    alert('Error al actualizar pedido');
  }
};


  const handleStatusChange = async (orderId, newStatus) => {
  try {
    const statusValue =
      newStatus === 'Terminar pedido'
        ? 'finished'
        : newStatus.toLowerCase().replace(/ /g, '-');

    await api.put(`/api/orders/${orderId}/status`, { status: statusValue });

    setOrders(prev =>
      prev.map(o => (o.id === orderId ? { ...o, status: statusValue } : o))
    );

    if (selectedOrder?.id === orderId) {
      setSelectedOrder(prev => ({ ...prev, status: statusValue }));
    }
  } catch (err) {
    console.error('Error al actualizar estado:', err);

    if (err?.response?.status === 401) {
      localStorage.removeItem('token');
      navigate('/'); // cambia a '/login' si tu login está ahí
      return;
    }

    alert('Error al actualizar el estado del pedido.');
  }
};


  // Función para imprimir la vista de pantalla completa
// Función para imprimir SOLO el contenido del modal (.print-format)
// en una ventana temporal (evita duplicados)
const handlePrint = () => {
  const printable = document.querySelector('.ao-modal .print-format');
  if (!printable) return;

  const html = `
    <html>
      <head>
        <meta charset="utf-8" />
        <title>Imprimir OR</title>
        <style>
          @page { size: A4 portrait; margin: 1.5cm; }
          body { font-family: Arial, sans-serif; color: #000; }
          .print-format { font-size: 16px; line-height: 1.5; }
          .print-format h3 { font-size: 20px; margin: 0.8rem 0 0.4rem; }
          hr { border: none; border-top: 1px solid #666; margin: 1rem 0; }
        </style>
      </head>
      <body>
        <div class="print-format">${printable.innerHTML}</div>
      </body>
    </html>`;

  const win = window.open('', 'PRINT_OR', 'width=900,height=700');
  if (!win) return; // por si el popup es bloqueado
  win.document.open();
  win.document.write(html);
  win.document.close();
  win.focus();
  win.print();
  setTimeout(() => win.close(), 300);
};

const handlePrintReceipt = () => {
  if (!selectedOrder) return;

  const order = selectedOrder;
  const popup = window.open(
    "",
    "PRINT_RECEIPT",
    "height=900,width=350"
  );

  // Fecha y hora de impresión
  // Fecha y hora de impresión
  const printedAt = new Date();
  const printedDate = printedAt.toLocaleDateString("es-CR");


  popup.document.write(`
    <html>
      <head>
        <title>Factura ${order.orderNumber}</title>
        <style>
          /* Ancho fijo para 80 mm ≈ 302px */
          body {
            width: 302px;
            margin: 0 auto;
            font-family: 'Arial', sans-serif;
            background-color: #fff;
            color: #000;
            font-size: 16px;
            line-height: 1.4;
          }

          /* Encabezado */
          .header {
            text-align: center;
            padding: 10px 0;
            border-bottom: 3px solid #000;
          }
          .header h1 {
            margin: 0;
            font-size: 24px;
            letter-spacing: 1px;
            font-weight: bold;
            text-transform: uppercase;
          }
          .header p {
            margin: 4px 0;
            font-size: 14px;
            font-weight: bold;
          }

          /* Bloques de información */
          .info-block {
            padding: 8px 0;
          }
          .info-block .row {
            display: flex;
            justify-content: space-between;
            margin: 4px 0;
          }
          .info-block .label {
            font-weight: bold;
            width: 45%;
            font-size: 16px;
          }
          .info-block .value {
            width: 50%;
            font-size: 16px;
            text-align: right;
            font-weight: normal;
          }

          /* Separadores */
          .separator {
            border-top: 1px dashed #000;
            margin: 8px 0;
          }

          /* Detalle del pedido */
          .detalle {
            margin: 6px 0;
          }
          .detalle p {
            font-size: 16px;
          }
          .detalle .label-detalle {
            font-weight: bold;
            font-size: 16px;
          }

          /* Totales económicos */
          .totals {
            margin-top: 8px;
          }
          .totals .row {
            display: flex;
            justify-content: space-between;
            margin: 4px 0;
          }
          .totals .label {
            font-weight: bold;
            font-size: 16px;
          }
          .totals .value {
            font-weight: bold;
            font-size: 16px;
            text-align: right;
          }

          /* Pie de página */
          .footer {
            margin-top: 10px;
            font-size: 14px;
            line-height: 1.2;
          }
          .footer p {
            margin: 2px 0;
            font-weight: normal;
          }

          @media print {
            body {
              margin: 0;
            }
          }
        </style>
      </head>
      <body>
        <!-- Encabezado de la Floristería -->
        <div class="header">
          <h1>FLORISTERÍA 2000</h1>
          <p>Floristeria2000, Calle 30, San José, San Bosco</p>
          <p>Correo: floristeria2000@hotmail.com | Tel: 2222-1657</p>
        </div>

        <!-- Datos de factura/pedido -->
        <div class="info-block">
          <div class="row">
            <span class="label">Factura N°:</span>
            <span class="value">${order.orderNumber}</span>
          </div>
          <div class="row">
            <span class="label">Fecha:</span>
            <span class="value">${printedDate}</span>
          </div>
          <div class="row">
            <span class="label">Cliente:</span>
            <span class="value">${order.customer || '---'}</span>
          </div>
        </div>

        <div class="separator"></div>

        <!-- Datos del pedido -->
        <div class="info-block">
          <div class="row">
            <span class="label">Fuente:</span>
            <span class="value">${order.fuente || '---'}</span>
          </div>
          <div class="row">
            <span class="label">Ejecutiv@:</span>
            <span class="value">${order.ejecutivo || '---'}</span>
          </div>
          <div class="row">
            <span class="label">Para:</span>
            <span class="value">${order.para || '---'}</span>
          </div>
          <div class="row">
            <span class="label">Teléfono:</span>
            <span class="value">${order.telefono || '---'}</span>
          </div>
          <div class="row">
            <span class="label">Entregar en:</span>
            <span class="value">${order.entregarEn || '---'}</span>
          </div>
        </div>

        <div class="separator"></div>

        <!-- Detalle del pedido -->
        <div class="detalle">
          <p class="label-detalle">Detalle del Pedido:</p>
          <p>${order.detalleEntrega || '---'}</p>
        </div>

        <div class="separator"></div>

        <!-- Tarjeta (solo si aplica) -->
  `);

  // Mostrar “Tarjeta” solo si order.tarjeta no es “No” ni vacío
  if (order.tarjeta && order.tarjeta.toLowerCase() !== "no") {
    popup.document.write(`
      <div class="info-block">
        <div class="row">
          <span class="label">Tarjeta:</span>
          <span class="value">${order.tarjetaDetalle || order.tarjeta}</span>
        </div>
      </div>
      <div class="separator"></div>
    `);
  }

  // Sección de Totales económicos, con lógica condicional de transporte
  popup.document.write(`
    <!-- Totales económicos -->
    <div class="totals">
      <div class="row">
        <span class="label">Parcial:</span>
        <span class="value">₡${(parseFloat(order.total) || 0).toFixed(2)}</span>
      </div>
  `);

  // Mostrar transporte solo si order.transporte > 0
  if (order.transporte && parseFloat(order.transporte) > 0) {
    popup.document.write(`
      <div class="row">
        <span class="label">Transporte:</span>
        <span class="value">₡${(parseFloat(order.transporte) || 0).toFixed(2)}</span>
      </div>
    `);
  }

  // Mostrar IVA si aplica
  if (order.iva === "Si") {
    const base = (parseFloat(order.total) || 0) + (parseFloat(order.transporte) || 0);
    const ivaAmt = (base * 0.13).toFixed(2);
    popup.document.write(`
      <div class="row">
        <span class="label">IVA (13%):</span>
        <span class="value">₡${ivaAmt}</span>
      </div>
    `);
  }

  // Total final (order.totalPayment)
  popup.document.write(`
      <div class="row">
        <span class="label">TOTAL:</span>
        <span class="value">₡${(parseFloat(order.totalPayment) || 0).toFixed(2)}</span>
      </div>
      <div class="row">
        <span class="label">Forma de pago:</span>
        <span class="value">${order.formaPago || '---'}</span>
      </div>
    </div>
  `);

  popup.document.write(`
        <div class="separator"></div>

        <!-- Pie de página para facturación -->
        <div class="footer">
          <p>Para su factura electrónica, rogamos enviar:</p>
          <p>– Nombre o Razón Social</p>
          <p>– Email, Teléfono, Dirección exacta</p>
          <p>al correo: Floristeria2000@hotmail.com</p>
        </div>
      </body>
    </html>
  `);

  popup.document.close();
  popup.focus();
  popup.print();

  setTimeout(() => {
    popup.close();
  }, 500);
};














  const getIvaAmount = order => {
    const base = (parseFloat(order.parcial) || 0) + (parseFloat(order.transporte) || 0);
    return (base * 0.13).toFixed(2);
  };

  const filteredOrders = orders.filter(order =>
    order.orderNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
    order.fuente.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (order.customer || '').toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="active-orders">
<header className="ao-header">
  <h1>Pedidos Activos</h1>
  <div className="ao-search-bar">
    <input
      type="text"
      className="ao-search-input"
      placeholder="Buscar pedido o cliente..."
      value={searchQuery}
      onChange={e => setSearchQuery(e.target.value)}
    />
    <button
      className="detail-button"
      onClick={() => navigate('/historial-pedidos')}
      aria-label="Ver historial de pedidos"
    >
      Ver historial de pedidos
    </button>
  </div>
</header>

      {/* Desktop Table */}
      <div className="ao-table-container only-desktop">
        <table className="ao-table">
          <thead>
            <tr>
              <th>Número</th>
              <th>Fuente</th>
              <th>Cliente</th>
              <th>Para</th>
              <th>Fecha y Hora</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrders.map(o => (
              <tr key={o.id}>
                <td>{o.orderNumber}</td>
                <td>{o.fuente}</td>
                <td>{o.customer}</td>
                <td>{o.para}</td>
                <td>{moment(o.scheduledTime).tz('America/Costa_Rica').format('DD/MM/YYYY h:mma')}</td>
                <td>
                  <select
                    value={formatStatus(o.status)}
                    onChange={e => handleStatusChange(o.id, e.target.value)}
                  >
                    <option>Pendiente</option>
                    <option>En Taller</option>
                    <option>Listo Para Entregar</option>
                    <option>Despachado</option>
                    <option>Terminar pedido</option>
                  </select>
                </td>
                <td>
                  <button className="detail-button" onClick={() => handleViewDetail(o)}>
                    Ver Detalle
                  </button>
                </td>
              </tr>
            ))}
            {filteredOrders.length === 0 && (
              <tr>
                <td colSpan="7">No se encontraron pedidos.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="order-card-container only-mobile">
        {filteredOrders.map(o => (
          <div key={o.id} className="order-card">
            <p><strong>Número:</strong> {o.orderNumber}</p>
            <p><strong>Fuente:</strong> {o.fuente}</p>
            <p><strong>Cliente:</strong> {o.customer}</p>
            <p><strong>Para:</strong> {o.para}</p>
            <p><strong>Fecha:</strong> {moment(o.scheduledTime).tz('America/Costa_Rica').format('DD/MM/YYYY h:mma')}</p>
            <div className="estado-wrapper">
              <label htmlFor={`estado-${o.id}`}>Estado:</label>
              <select
                id={`estado-${o.id}`}
                value={formatStatus(o.status)}
                onChange={e => handleStatusChange(o.id, e.target.value)}
              >
                <option>Pendiente</option>
                <option>En Taller</option>
                <option>Listo Para Entregar</option>
                <option>Despachado</option>
                <option>Terminar pedido</option>
              </select>
            </div>
            <button className="detail-button" onClick={() => handleViewDetail(o)}>
              Ver Detalle
            </button>
          </div>
        ))}
      </div>

      {/* Modal */}
      {modalOpen && selectedOrder && (
        <div className="ao-modal-overlay">
          <div className="ao-modal">
            <div className="ao-modal-header">
              <h2>Detalle del Pedido</h2>
              <button className="close-button" onClick={handleCloseModal}>X</button>
            </div>

            <div className="print-format">
              {!editMode ? (
                selectedOrder.orderNumber.startsWith('OR-') ? (
                  /* Versión simplificada para OR- */
                  <div className="orden-ventana">
                    <p><strong>Número:</strong> {selectedOrder.orderNumber}</p>
                    <p><strong>Ejecutiv@:</strong> {selectedOrder.ejecutivo}</p>
                    <p><strong>Cliente:</strong> {selectedOrder.customer}</p>
                    <p><strong>Para:</strong> {selectedOrder.para}</p>
                    <p><strong>Monto base:</strong> ¢{selectedOrder.total}</p>
                    <p><strong>IVA:</strong> {selectedOrder.iva}</p>
                    <p><strong>Total:</strong> ¢{selectedOrder.totalPayment}</p>
                    <p><strong>Fecha y Hora:</strong> {moment(selectedOrder.scheduledTime).tz('America/Costa_Rica').format('DD/MM/YYYY h:mma')}</p>
                    <p><strong>Detalle:</strong> {selectedOrder.detalleEntrega}</p>
                    <p><strong>Recibido por:</strong> {selectedOrder.recibidoPor}</p>
                    <p><strong>Forma de Pago:</strong> {selectedOrder.formaPago}</p>

                    <hr />

                    <p style={{ fontSize: '0.8rem', color: '#ccc', marginTop: '1rem' }}>
                      Para su factura electrónica, le rogamos enviar los siguientes datos: <br />
                      Nombre o Razón Social, Cédula física o jurídica, Email, teléfono, dirección exacta <br />
                      al correo: <strong>Floristeria2000@hotmail.com</strong>
                    </p>
                  </div>
                ) : (
                  /* Versión completa para F2000- */
                  <>
                    <div className="orden-entrega">
                      <h3>ORDEN DE ENTREGA NÚMERO <span>{selectedOrder.orderNumber}</span></h3>
                      <div className="row">
                        <div className="edit-form-group"><p><strong>Fuente:</strong> {selectedOrder.fuente}</p></div>
                        <div className="edit-form-group"><p><strong>Ejecutiv@:</strong> {selectedOrder.ejecutivo}</p></div>
                      </div>
                      <div className="row">
                        <div className="edit-form-group"><p><strong>Para:</strong> {selectedOrder.para}</p></div>
                        <div className="edit-form-group"><p><strong>Teléfono:</strong> {selectedOrder.telefono}</p></div>
                      </div>
                      <p><strong>Entregar En:</strong> {selectedOrder.entregarEn}</p>
                      <p><strong>Fecha y Hora:</strong> {moment(selectedOrder.scheduledTime).tz('America/Costa_Rica').format('DD/MM/YYYY h:mma')}</p>
                      <p><strong>Detalle:</strong> {selectedOrder.detalleEntrega}</p>
                      <p>
  <strong>Tarjeta:</strong>{" "}
  {selectedOrder.tarjeta === "Si"
    ? (selectedOrder.tarjetaDetalle || "Sin detalle")
    : "No"}
</p>

                      <p><strong>Recibido por:</strong> {selectedOrder.recibidoPor}</p>
                    </div>
                    <hr/>
                    <div className="orden-produccion">
                      <h3>ORDEN DE PRODUCCIÓN NÚMERO <span>{selectedOrder.orderNumber}</span></h3>
                      <div className="row">
                        <div className="edit-form-group"><p><strong>Fuente:</strong> {selectedOrder.fuente}</p></div>
                        <div className="edit-form-group"><p><strong>Ejecutiv@:</strong> {selectedOrder.ejecutivo}</p></div>
                      </div>
                      <div className="row">
                        <div className="edit-form-group"><p><strong>Para:</strong> {selectedOrder.para}</p></div>
                        <div className="edit-form-group"><p><strong>Teléfono:</strong> {selectedOrder.telefono}</p></div>
                      </div>
                      <p><strong>Fecha y Hora:</strong> {moment(selectedOrder.scheduledTime).tz('America/Costa_Rica').format('DD/MM/YYYY h:mma')}</p>
                      <p><strong>Detalle:</strong> {selectedOrder.detalleEntrega}</p>
                      <p><strong>Parcial:</strong> ¢{selectedOrder.total}</p>
                      <p><strong>Transporte:</strong> ¢{selectedOrder.transporte}</p>
                      <p><strong>IVA:</strong> {selectedOrder.iva === 'Si' ? `¢${getIvaAmount(selectedOrder)}` : 'N/A'}</p>
                      <p><strong>Total:</strong> ¢{selectedOrder.totalPayment}</p>
                      <p><strong>Forma de Pago:</strong> {selectedOrder.formaPago}</p>
                    </div>
                  </>
                )
              ) : (
                /* Modo edición */
                (selectedOrder.orderNumber.startsWith('OR-') ? (
                  /* Formulario OR-N */
                  <form onSubmit={handleUpdateOrder} className="edit-form">
                    <h3>Editar Ventana #{selectedOrder.orderNumber}</h3>

                    <div className="row">
                      <div className="edit-form-group">
                        <label htmlFor="ejecutivo">Ejecutiv@:</label>
                        <input
                          id="ejecutivo"
                          name="ejecutivo"
                          value={editForm.ejecutivo}
                          onChange={handleEditFormChange}
                        />
                      </div>
                      <div className="edit-form-group">
                        <label htmlFor="customer">Cliente:</label>
                        <Select
                          id="customer"
                          name="customer"
                          options={clientOptions}
                          value={clientOptions.find(o => o.value === editForm.customer) || null}
                          onChange={opt => setEditForm(f => ({ ...f, customer: opt?.value || '' }))}
                          isClearable
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="edit-form-group">
                        <label htmlFor="para">Para:</label>
                        <input
                          id="para"
                          name="para"
                          value={editForm.para}
                          onChange={handleEditFormChange}
                        />
                      </div>
                      <div className="edit-form-group">
                        <label>Entregar el:</label>
                        <DatePicker
                          selected={new Date(editForm.scheduledTime)}
                          onChange={date => setEditForm(f => ({ ...f, scheduledTime: date }))}
                          showTimeSelect
                          dateFormat="dd/MM/yyyy h:mm aa"
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="edit-form-group">
                        <label htmlFor="parcial">Monto base:</label>
                        <input
                          type="number"
                          id="parcial"
                          name="parcial"
                          value={editForm.parcial}
                          onChange={handleEditFormChange}
                        />
                      </div>
                      <div className="edit-form-group">
                        <label htmlFor="iva">IVA:</label>
                        <select
                          id="iva"
                          name="iva"
                          value={editForm.iva}
                          onChange={handleEditFormChange}
                        >
                          <option value="No">No</option>
                          <option value="Si">Sí (13%)</option>
                        </select>
                      </div>
                    </div>

                    <div className="row">
                      <div className="edit-form-group">
                        <label htmlFor="detalleEntrega">Detalle:</label>
                        <textarea
                          id="detalleEntrega"
                          name="detalleEntrega"
                          value={editForm.detalleEntrega}
                          onChange={handleEditFormChange}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="edit-form-group">
                        <label htmlFor="recibidoPor">Recibido por:</label>
                        <input
                          id="recibidoPor"
                          name="recibidoPor"
                          value={editForm.recibidoPor}
                          onChange={handleEditFormChange}
                        />
                      </div>
                      <div className="edit-form-group">
                        <label htmlFor="formaPago">Forma de Pago:</label>
                        <select
                          id="formaPago"
                          name="formaPago"
                          value={editForm.formaPago}
                          onChange={handleEditFormChange}
                        >
                          <option value="">Seleccione...</option>
                          <option value="EFECTIVO">Efectivo</option>
                          <option value="TARJETA">Tarjeta</option>
                          <option value="SINPE">SINPE</option>
                        </select>
                      </div>
                    </div>

                    <div className="ao-modal-actions">
                      <button type="submit">Guardar Cambios</button>
                      <button type="button" onClick={() => setEditMode(false)}>
                        Cancelar
                      </button>
                    </div>
                  </form>
                ) : (
                  /* Formulario F2000-N */
                  <form onSubmit={handleUpdateOrder} className="edit-form">
                    <h3>Editar Pedido #{selectedOrder.orderNumber}</h3>

                    <div className="row">
                      <div className="edit-form-group">
                        <label htmlFor="fuente">Fuente:</label>
                        <input
                          id="fuente"
                          name="fuente"
                          value={editForm.fuente}
                          onChange={handleEditFormChange}
                        />
                      </div>
                      <div className="edit-form-group">
                        <label htmlFor="ejecutivo">Ejecutiv@:</label>
                        <input
                          id="ejecutivo"
                          name="ejecutivo"
                          value={editForm.ejecutivo}
                          onChange={handleEditFormChange}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="edit-form-group">
                        <label htmlFor="customer">Cliente:</label>
                        <Select
                          id="customer"
                          name="customer"
                          options={clientOptions}
                          value={clientOptions.find(o => o.value === editForm.customer) || null}
                          onChange={opt => setEditForm(f => ({ ...f, customer: opt?.value || '' }))}
                          isClearable
                        />
                      </div>
                      <div className="edit-form-group">
                        <label htmlFor="para">Para:</label>
                        <input
                          id="para"
                          name="para"
                          value={editForm.para}
                          onChange={handleEditFormChange}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="edit-form-group">
                        <label>Fecha y Hora de Entrega:</label>
                        <DatePicker
                          selected={new Date(editForm.scheduledTime)}
                          onChange={date => setEditForm(f => ({ ...f, scheduledTime: date }))}
                          showTimeSelect
                          dateFormat="dd/MM/yyyy h:mm aa"
                        />
                      </div>
                      <div className="edit-form-group">
                        <label htmlFor="entregarEn">Entregar En:</label>
                        <input
                          id="entregarEn"
                          name="entregarEn"
                          value={editForm.entregarEn}
                          onChange={handleEditFormChange}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="edit-form-group">
                        <label htmlFor="parcial">Parcial:</label>
                        <input
                          type="number"
                          id="parcial"
                          name="parcial"
                          value={editForm.parcial}
                          onChange={handleEditFormChange}
                        />
                      </div>
                      <div className="edit-form-group">
                        <label htmlFor="transporte">Transporte:</label>
                        <input
                          type="number"
                          id="transporte"
                          name="transporte"
                          value={editForm.transporte}
                          onChange={handleEditFormChange}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="edit-form-group">
                        <label htmlFor="iva">IVA (Si/No):</label>
                        <select
                          id="iva"
                          name="iva"
                          value={editForm.iva}
                          onChange={handleEditFormChange}
                        >
                          <option value="No">No</option>
                          <option value="Si">Si</option>
                        </select>
                      </div>
                      <div className="edit-form-group">
                        <label>Total Calculado:</label>
                        <input
                          type="text"
                          readOnly
                          value={(() => {
                            const base = (parseFloat(editForm.parcial) || 0) + (parseFloat(editForm.transporte) || 0);
                            return editForm.iva === 'Si'
                              ? (base * 1.13).toFixed(2)
                              : base.toFixed(2);
                          })()}
                        />
                      </div>
                    </div>

                    <div className="edit-form-group">
                      <label htmlFor="detalleEntrega">Detalle de Entrega:</label>
                      <textarea
                        id="detalleEntrega"
                        name="detalleEntrega"
                        rows="3"
                        value={editForm.detalleEntrega}
                        onChange={handleEditFormChange}
                      />
                    </div>

                    <div className="row">
                      <div className="edit-form-group">
                        <label htmlFor="recibidoPor">Recibido por:</label>
                        <input
                          id="recibidoPor"
                          name="recibidoPor"
                          value={editForm.recibidoPor}
                          onChange={handleEditFormChange}
                        />
                      </div>
                      <div className="edit-form-group">
                        <label htmlFor="formaPago">Forma de Pago:</label>
                        <select
                          id="formaPago"
                          name="formaPago"
                          value={editForm.formaPago}
                          onChange={handleEditFormChange}
                        >
                          <option value="">Seleccione...</option>
                          <option value="SINPE">SINPE</option>
                          <option value="CRÉDITO">CRÉDITO</option>
                          <option value="TRANSFERENCIA BANCARIA">TRANSFERENCIA BANCARIA</option>
                          <option value="PAYPAL">PAYPAL</option>
                          <option value="WESTERN UNION">WESTERN UNION</option>
                          <option value="EFECTIVO">EFECTIVO</option>
                          <option value="TARJETA">TARJETA</option>
                        </select>
                      </div>
                    </div>

                    <div className="row">
                      <div className="edit-form-group">
                        <label htmlFor="tarjeta">Tarjeta (Si/No):</label>
                        <select
                          id="tarjeta"
                          name="tarjeta"
                          value={editForm.tarjeta}
                          onChange={handleEditFormChange}
                        >
                          <option value="No">No</option>
                          <option value="Si">Si</option>
                        </select>
                      </div>
                      {editForm.tarjeta === 'Si' && (
                        <div className="edit-form-group">
                          <label htmlFor="tarjetaDetalle">Detalle de Tarjeta:</label>
                          <input
                            type="text"
                            id="tarjetaDetalle"
                            name="tarjetaDetalle"
                            value={editForm.tarjetaDetalle}
                            onChange={handleEditFormChange}
                          />
                        </div>
                      )}
                    </div>

                    <div className="ao-modal-actions">
                      <button type="submit" className="print-button">Guardar Cambios</button>
                      <button type="button" onClick={() => setEditMode(false)}>Cancelar</button>
                    </div>
                  </form>
                ))
              )}
            </div>

            <div className="ao-modal-actions">
              {!editMode && <button className="print-button" onClick={handlePrint}>Imprimir</button>}
              {!editMode && (
                <button className="print-receipt-button" onClick={handlePrintReceipt}>
                  Imprimir OR (Ticket 80 mm)
                </button>
              )}
              {!editMode && <button onClick={handleEditOrder}>Editar Pedido</button>}
              <button onClick={handleCloseModal}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActiveOrders;
